import React from 'react';
import { ModalDeleteUserProps } from './types';
import { Button } from '@vtbhome/juicyfront';
import { Body, Footer, Subscription } from './modal-delete-user.styles';
import { Typography } from '../../../../../shared/ui/typography/typography';
import { UserInfo } from '../user-info/user-info';
import { getUserStatus } from '@shared/lib/utils/get-user-status/get-user-status';
import { CACHE_KEY_USER_DELETE } from '../../config/api-constants';
import { useUserDeleteMutation } from '../../api/user-delete-api';
import { Modal } from '@shared/ui/modal/modal';
import { userName } from '@shared/lib/utils/user-name/user-name';

export const ModalDeleteUser: React.FC<ModalDeleteUserProps> = ({ isShow, user, onClose, onAccept }) => {
    const [deleteUser, deleteUserResult] = useUserDeleteMutation({ fixedCacheKey: CACHE_KEY_USER_DELETE });
    const isLoading = deleteUserResult.isLoading;

    const handleAccept = async () => {
        await deleteUser(user.id);
        onAccept();
    };

    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={<Typography size='h5'>Удаление пользователя</Typography>}
            footer={
                <Footer>
                    <Button disabled={isLoading} buttonType='light' onClick={onClose}>
                        Отменить
                    </Button>
                    <Button preloader={isLoading} disabled={isLoading} buttonType='primary' onClick={handleAccept}>
                        Подтвердить
                    </Button>
                </Footer>
            }
            onClose={onClose}>
            <Body>
                <Subscription size='body1_short'>
                    {`Обратите внимание, данное действие необратимо.\nВы действительно хотите удалить данного пользователя?`}
                </Subscription>
                <UserInfo
                    avatarUrl={user.photoUrl}
                    name={
                        userName({
                            firstName: user.firstName || '',
                            lastName: user.lastName || '',
                            middleName: user.middleName || '',
                        }).full
                    }
                    organizationPost={user.jobTitle}
                    status={getUserStatus(user)}
                />
            </Body>
        </Modal>
    );
};
